import Base from '../../_config/base';

class Cards extends Base {
  constructor(el) {
    super(el);

    this.config = {
      time: 10,
      show: false,
    };

    this.numbers = el.querySelectorAll('.number');
    this.card = el;
    window.addEventListener('scroll', () => this.turnOnIncreasing());
    window.addEventListener('load', () => this.turnOnIncreasing());
  }

  turnOnIncreasing() {
    if (!this.config.show && this.isInViewport(this.$el)) {
      this.config.show = true;
      const number = this.card.querySelector('.card__item_title').textContent.replaceAll("'", '').replaceAll('’', '').replaceAll(' ', '');

      if (!Number.isNaN(+number)) {
        this.numberIncrease(this.card.querySelector('.card__item_title'));
      }
    }
  }

  numberIncrease(elem) {
    let n = 0;

    const num = +elem.textContent.replaceAll("'", '').replaceAll('’', '').replaceAll(' ', '');
    // eslint-disable-next-line no-nested-ternary
    const step = num > 10000
      ? 100
      : num > 1000
        ? 50
        : 1;

    elem.classList.add('show');
    const t = this.config.time / num;

    const interval = setInterval(() => {
      num - n <= step ? n += (num - n) : n += step;
      if (n >= num) {
        clearInterval(interval);
      }
      const formattedNumber = new Intl.NumberFormat('de-CH').format(n);
      elem.innerHTML = formattedNumber;
    }, t * 100);
  }

  // eslint-disable-next-line class-methods-use-this
  isInViewport(elem) {
    const distance = elem.getBoundingClientRect();
    return distance.top < window.innerHeight - 100;
  }
}

Cards.className = 'Cards';
export default Cards;
